module.exports = __webpack_public_path__ + "img/itleague-logo.e6814ade.svg";